import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if the current location has a hash (specific section)
    const hasHash = location.hash && location.hash !== '';
    
    // Check if it's a HashLink navigation (from QuickLinks with #)
    const isHashLink = location.pathname.includes('#') || 
                      (location.state && location.state.hashLink);
    
    // Check if it's a regular Link with section parameter (like ?section=top)
    const hasSectionParam = location.search && location.search.includes('section=');
    
    // Handle section-based navigation for both HashLinks and regular Links
    if (hasSectionParam) {
      // Extract section from query parameter
      const urlParams = new URLSearchParams(location.search);
      const section = urlParams.get('section');
      
      if (section) {
        // Find the element with the section ID
        const element = document.getElementById(section);
        if (element) {
          const yCoordinate = element.getBoundingClientRect().top + window.pageYOffset;
          const yOffset = -120; // adjust this value to your header height
          window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
          return;
        }
      }
    }
    
    // Only scroll to top if there's no hash, no section param, and it's not a HashLink navigation
    if (!hasHash && !hasSectionParam && !isHashLink) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, [location]);

  return null;
};

export default ScrollToTop;
